import React from 'react';
import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';
import { ReactComponent as LeftIcon } from '../../../features/forum/assets/images/left.svg';
import { ReactComponent as RightIcon } from '../../../features/forum/assets/images/right.svg';
import './paginationStyle.js';
import { PaginationContainer } from './paginationStyle.js';

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
    icon,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <PaginationContainer className={classnames({ [className]: className })}>
      <li
        className={classnames('pagination-item', {
          disabled: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        {icon ? <LeftIcon /> : 'Previous'}
      </li>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <li key={index} className="pagination-item dots">
              &#8230;
            </li>
          );
        }

        return (
          <li
            key={index}
            className={classnames('pagination-item', {
              selected: pageNumber === currentPage,
            })}
            onClick={() =>
              pageNumber !== currentPage && onPageChange(pageNumber)
            }
          >
            {pageNumber}
          </li>
        );
      })}
      <li
        key={'page'}
        className={classnames('pagination-item', {
          disabled: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        {icon ? <RightIcon /> : 'Next'}
      </li>
    </PaginationContainer>
  );
};

export default Pagination;
